enum CurrentSignal {
  BUY = "Buy",
  NEUTRAL = "Neutral",
  SELL = "Sell",
}

export default CurrentSignal;
